import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentProductos } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContentService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any>(`${environmentProductos.apiUrl}/Content/Get`);
    }

    getAllById(id) {
        return this.http.get<any>(`${environmentProductos.apiUrl}/Content/GetByVarietyID?VarietyId=`+id);
    }

}